import { render } from "./SeperateView.vue?vue&type=template&id=749320f0"
import script from "./SeperateView.vue?vue&type=script&lang=js"
export * from "./SeperateView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__